import React from 'react';
import CallServiceSearchContainer from './call-service-search-container';

const CallServiceSearchPage = () => {
  return <CallServiceSearchContainer />;
};

export default CallServiceSearchPage;
